import getObjectKey from 'lib/object/getObjectKey'
import type { BurnBatchRequest } from 'api/loyalty/requestLoyaltyPointsBurnCalculationBatch'

function buildBurnKey(
  request: BurnBatchRequest,
  customerId: string,
): string {
  return getObjectKey({
    price: request.price,
    loyaltyProductType: request.loyaltyProductType,
    mx: request.mx,
    customerId,
  })
}

export default buildBurnKey
